import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BingoTournamentsService } from '@frontend/bingo/frontend-lib/core';

import { BingoSlotRaceCardComponent } from '../cards-wrapper/card/bingo-card.component';

@Component({
    selector: 'bgl-notification-popup',
    templateUrl: 'bingo-notification-popup.component.html',
    imports: [CommonModule, BingoSlotRaceCardComponent],
})
export class BingoNotificationPopUpComponent implements OnInit {
    notificationOnMsg: string;
    notificationOffMsg: string;
    constructor(
        private dialogRef: MatDialogRef<BingoNotificationPopUpComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private slotRacesService: BingoTournamentsService,
    ) {}

    ngOnInit() {
        if (this.data.status === true) {
            this.notificationOnMsg = this.data.messages.NotificationMsgOnText;
        } else {
            this.notificationOffMsg = this.data.messages.NotificationMsgOffText;
        }

        const timeout = this.slotRacesService.notificationPopupTimeout();

        setTimeout(() => {
            this.close();
        }, timeout);
    }

    close() {
        this.dialogRef.close();
    }
}
